import { apiPost, apiGet } from './api';
import {
  DepositSession,
  Transfer,
  WithdrawalRequest,
  WithdrawalResult,
} from '../types/payment';

export async function createDepositSession(
  amount: number,
): Promise<DepositSession> {
  return apiPost<DepositSession>('/payments/create-checkout-session', { amount });
}

export async function requestWithdrawal(
  req: WithdrawalRequest,
): Promise<WithdrawalResult> {
  return apiPost<WithdrawalResult>('/payments/withdrawals', req);
}

export async function fetchTransfers(): Promise<Transfer[]> {
  return apiGet<Transfer[]>('/profile/transfers');
}
